module.exports = __webpack_public_path__ + "img/2.22d91f9c.jpg";